import { makeStyles } from "@fluentui/react-components";
import { customTokens, customTypographyStyles } from "../../theme/theme";

const useHeaderStyles = makeStyles({
  header: {
    backgroundColor: customTokens.UNFCCCPrimaryOcean100,
    color: customTokens.colorNeutralForegroundInverted,
    transition: "all 0.3s ease",
  },

  headerContent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    margin: "0 auto",
    borderBottom: `1px solid ${customTokens.colorNeutralStrokeAlpha2}`,
    padding: "12px 240px",

    "@media (max-width: 1440px)": {
      padding: "12px 120px",
    },

    "@media (min-width: 769px) and (max-width: 1024px)": {
      padding: "12px 64px",
    },

    "@media (max-width: 768px)": {
      padding: "12px 20px",
    },
  },

  logoSection: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },

  logo: {
    height: "54px",
    width: "184px",
    cursor: "pointer",
  },

  divider: {
    height: "35px",
  },

  rightSection: {
    display: "flex",
    alignItems: "center",
    gap: "24px",
  },

  unfcccLink: {
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    cursor: "pointer",
    color: customTokens.colorNeutralForegroundInverted,
    ...customTypographyStyles.body1,
    "&:hover": {
      textDecoration: "underline",
    },
  },

  navContainer: {
    backgroundColor: customTokens.UNFCCCPrimaryOcean100,
  },

  navContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: "0 auto",
    padding: "16px 240px",

    "@media (max-width: 1440px)": {
      padding: "16px 120px",
    },

    "@media (min-width: 769px) and (max-width: 1024px)": {
      padding: "16px 64px",
    },

    "@media (max-width: 768px)": {
      alignItems: "flex-start",
      padding: "16px 20px",
    },
  },

  navItems: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    gap: "0",
    listStyle: "none",
    padding: 0,
  },

  navItem: {
    textDecoration: "none",
    cursor: "pointer",
    color: customTokens.colorNeutralForegroundInverted,
    ...customTypographyStyles.body3,
  },

  activeNavItem: {
    borderBottom: `3px solid ${customTokens.colorNeutralForegroundInverted}`,
  },

  navItemWrapper: {
    position: "relative",
  },

  dropdownMenu: {
    position: "absolute",
    top: "150%",
    left: 0,
    backgroundColor: customTokens.UNFCCCPrimaryOcean100,
    minWidth: "300px",
    zIndex: 1000,
    display: "flex",
    flexDirection: "column",
    boxShadow: customTokens.shadow16,
    borderRadius: customTokens.borderRadiusMedium,
  },

  dropdownItem: {
    ...customTypographyStyles.body1,
    margin: "0 4px",
    padding: "8px",
    color: "white",
    textDecoration: "none",
    borderBottom: `1px solid ${customTokens.UNFCCCPrimaryOcean90}`,
  },

  disabled: {
    color: customTokens.UNFCCCPrimaryOcean90,
    cursor: "default",
  },
});

export default useHeaderStyles;
